import Link from 'next/link';

import { ArrowRightNew } from '@/components/SvgComponents';

import styles from './index.module.scss';

export const ToolbarBanner = ({ data }) => {
  return (
    <div
      className={styles.wrapper}
      itemScope
      itemType='https://schema.org/WebPage'
    >
      <h1>{data?.title}</h1>
      <p>{data?.description}</p>
      <Link
        href={data?.button_slug}
        aria-label='Buy Number'
        rel='noopener noreferrer'
      >
        <a>
          {data?.button_text} <ArrowRightNew />
        </a>
      </Link>
    </div>
  );
};
